// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import axios from 'axios';
import qs from 'qs';
import { reportError } from './plugins/owl';

Vue.config.productionTip = false
// console.log('VUE_APP_ENV:', process.env)
window.owl('config', {
  devMode: process.env.NODE_ENV !== 'production'
})
/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(VueJsonPretty)
Vue.prototype.$http = axios
Vue.prototype.$qs = qs

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

// 获取匿名唯一标识，存储到 localStorage 中保证同一设备稳定
function getAnonymousUserId() {
  const key = 'pki_anonymous_uid'
  try {
    let uid = localStorage.getItem(key)
    if (!uid) {
      uid = 'anon_' + crypto.randomUUID()
      localStorage.setItem(key, uid)
    }
    return uid
  } catch (e) {
    // localStorage 不可用（隐私模式/存储被禁用）或 crypto.randomUUID 不可用时降级处理
    return 'anon_' + Date.now() + '_' + Math.random().toString(36).slice(2)
  }
}

// 对外网站证书检测 SDK 初始化
function initCertCheck() {
  try {
    if (window.BfePkiCertManager && window.BfePkiCertManager.init) {
      window.BfePkiCertManager.init({
        bizName: 'lbs.meituan.com',
        userId: getAnonymousUserId(),
        autoPopup: true
      }).then(function (result) {
        console.log('[CertCheck] 证书检测完成，result:', result)
      }).catch(function (error) {
        console.error('[CertCheck] 证书检测异常:', error)
      })
    } else {
      console.warn('[CertCheck] BfePkiCertManager 未加载')
    }
  } catch (e) {
    console.error('[CertCheck] 证书检测 SDK 初始化失败:', e)
    reportError('CertCheckInitError', e)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initCertCheck()
})
